import * as React from "react";

import { Root } from "./CrossfitTableHeaderRow.styles";

interface CrossfitTableHeaderRowProps {
    subkind?: "numbers";
    isLast: boolean;
    isLast2: boolean;
    children: readonly React.ReactNode[];
}

export function CrossfitTableHeaderRow(props: CrossfitTableHeaderRowProps): JSX.Element {
    return (
        <Root subkind={props.subkind} isLast={props.isLast} showBottomBorder={!props.isLast2}>
            {props.children}
        </Root>
    );
}
